const questionnaireSummariesPath = '/questionnaire-summaries';
export default questionnaireSummariesPath;
